import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToCollection } from '../services/database';
import uuid from 'react-uuid';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: auto;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
`;

const Title = styled.h2`
    text-align: center;
    color: #333;
    margin-bottom: 20px;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const Input = styled.input`
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    outline: none;
    &:focus {
        border-color: #007bff;
    }
`;

const Button = styled.button`
    background: #007bff;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        background: #0056b3;
    }
`;

const Loader = styled.div`
    width: 20px;
    height: 20px;
    border: 3px solid white;
    border-top: 3px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

const Message = styled.p`
    text-align: center;
    color: green;
    font-weight: bold;
    margin-top: 10px;
`;

const AddCertificate = () => {
    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [points, setPoints] = useState('');
    const [approvals, setApprovals] = useState('');
    const [approvalDate, setApprovalDate] = useState('');
    const [users, setUsers] = useState('');
    const [certificateIds, setCertificateIds] = useState('');
    const [userNames, setUserNames] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
    
        const userList = users.split(',');
        const certificateIdsList = certificateIds.split(',');
        const namesList = userNames.split(',');
    
        // Kreiramo listu certifikata
        const certificates = userList.map((user, index) => ({
            id: uuid(),
            title,
            subtitle,
            points,
            approvals,
            approval_date: approvalDate,
            email: user.trim(),
            name: namesList[index]?.trim() || '',
            certificate_number: certificateIdsList[index]?.trim() || ''
        }));
    
        try {
            // **Prvo upisujemo sve certifikate u bazu**
            await Promise.all(certificates.map(cert => addToCollection('certificates', cert.id, cert)));
    
            // **Ako je upis u bazu uspješan, tek onda šaljemo emailove**
            const response = await fetch('https://revicon.info/api/pdf-certificate-mailer', {
                body: JSON.stringify(certificates),  // Šaljemo listu certifikata
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });
    
            if (response.ok) {
                setMessage(`Uspješno kreirano ${certificates.length} certifikata.`);
            } else {
                setMessage('Greška prilikom slanja emailova.');
            }
        } catch (error) {
            console.error('Greška prilikom upisa u bazu:', error);
            setMessage('Greška prilikom upisa u bazu.');
        } finally {
            setLoading(false);
        }
    };
    
    
    return (
        <Container>
            <Title>Dodaj certifikat</Title>
            <Form onSubmit={handleSubmit}>
                <Input type="text" placeholder="Naslov" value={title} onChange={(e) => setTitle(e.target.value)} required />
                <Input type="text" placeholder="Podnaslov" value={subtitle} onChange={(e) => setSubtitle(e.target.value)} required />
                <Input type="number" placeholder="Broj poena" value={points} onChange={(e) => setPoints(e.target.value)} required />
                <Input type="text" placeholder="Broj odobrenja" value={approvals} onChange={(e) => setApprovals(e.target.value)} required />
                <Input type="date" value={approvalDate} onChange={(e) => setApprovalDate(e.target.value)} required />
                <Input type="text" placeholder="Korisnici (email)" value={users} onChange={(e) => setUsers(e.target.value)} required />
                <Input type="text" placeholder="Brojevi certifikata" value={certificateIds} onChange={(e) => setCertificateIds(e.target.value)} required />
                <Input type="text" placeholder="Imena korisnika" value={userNames} onChange={(e) => setUserNames(e.target.value)} required />
                <Button type="submit">{loading ? <Loader /> : 'Kreiraj certifikat'}</Button>
            </Form>
            {message && <Message>{message}</Message>}
        </Container>
    );
};

export default AddCertificate;